import StoreLocatorPage from "../pages/StoreLocatorPage";
import styled from "styled-components";
import CustomHempRetailers from "../components/CustomHempRetailers";

const StlWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    margin: 100px auto 70px auto;
  }
`;

const D9StoreFinderSlice = (props) => {
  return (
    <StlWrapper>
      <CustomHempRetailers>
        {({ customStores, customStoresLoading }) => (
          <StoreLocatorPage
            brand="Good News - Hemp"
            customStyles={true}
            customStores={customStores}
            customStoresLoading={customStoresLoading}
          />
        )}
      </CustomHempRetailers>
    </StlWrapper>
  );
};

export default D9StoreFinderSlice;
